// Legal content for Gold Media Studio. Placeholders in [BRACKETS] must be
// completed by the studio (address, phone, hosting provider, exact date).

export const IMPRESSUM = {
  slug: "impressum",
  title: "Impressum",
  subtitle: "Angaben gemäß § 5 DDG",
  blocks: [
    {
      title: "Anbieter",
      body: ["Gold Media Studio", "Hamburg, Deutschland"],
    },
    {
      title: "Kontakt",
      body: ["E-Mail: kontakt@goldmediastudio.de"],
    },
    {
      title: "Verantwortlich für den Inhalt",
      body: ["Gold Media Studio", "Hamburg, Deutschland"],
    },
    {
      title: "Haftung für Inhalte",
      body: [
        "Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.",
      ],
    },
    {
      title: "Haftung für Links",
      body: [
        "Unser Angebot enthält gegebenenfalls Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.",
      ],
    },
  ],
};

export const DATENSCHUTZ = {
  slug: "datenschutz",
  title: "Datenschutzerklärung",
  subtitle: "Informationen zur Verarbeitung Ihrer personenbezogenen Daten",
  blocks: [
    {
      title: "1. Verantwortlicher",
      body: [
        "Verantwortlicher für die Verarbeitung personenbezogener Daten auf dieser Website ist:",
        "Gold Media Studio",
        "Hamburg, Deutschland",
        "E-Mail: kontakt@goldmediastudio.de",
      ],
    },
    {
      title: "2. Allgemeine Hinweise",
      body: [
        "Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.",
        "Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.",
      ],
    },
    {
      title: "3. Hosting",
      body: [
        "Beim Aufruf der Website können durch den Hosting-Anbieter technisch erforderliche Daten verarbeitet werden, insbesondere IP-Adresse, Datum und Uhrzeit des Zugriffs, Browsertyp, Betriebssystem und aufgerufene Seiten.",
        "Die Verarbeitung erfolgt zur sicheren und zuverlässigen Bereitstellung der Website.",
      ],
    },
    {
      title: "4. Kontaktaufnahme",
      body: [
        "Wenn Sie uns über das Kontaktformular, per E-Mail oder auf anderem Wege kontaktieren, verarbeiten wir die von Ihnen übermittelten Daten zur Bearbeitung Ihrer Anfrage.",
        "Dies können insbesondere sein:",
      ],
      bullets: [
        "Name",
        "E-Mail-Adresse",
        "Telefonnummer",
        "Unternehmen",
        "Angaben zu Ihrem Projekt",
        "sonstige von Ihnen freiwillig übermittelte Informationen",
      ],
      after: [
        "Die Verarbeitung erfolgt zur Bearbeitung Ihrer Anfrage und gegebenenfalls zur Vorbereitung oder Durchführung eines Vertrags.",
      ],
    },
    {
      title: "5. Terminbuchung",
      body: [
        "Wenn Sie über unsere Website einen Beratungstermin buchen, können dabei personenbezogene Daten wie Name, E-Mail-Adresse, Terminangaben und weitere von Ihnen eingegebene Informationen verarbeitet werden.",
        "Für die Terminbuchung setzen wir den Dienst Calendly (Calendly LLC, USA) ein. Bei der Nutzung werden die von Ihnen eingegebenen Daten an Calendly übermittelt und dort nach den Datenschutzbestimmungen des Anbieters verarbeitet. Weitere Informationen finden Sie unter https://calendly.com/privacy.",
      ],
    },
    {
      title: "6. Cookies",
      body: [
        "Unsere Website kann Cookies und ähnliche Technologien verwenden.",
        "Technisch notwendige Cookies können erforderlich sein, damit die Website ordnungsgemäß funktioniert.",
        "Nicht notwendige Cookies, beispielsweise für Analyse- oder Marketingzwecke, werden nur eingesetzt, soweit hierfür eine entsprechende Rechtsgrundlage bzw. Einwilligung erforderlich ist.",
        "Sie können Ihre Cookie-Einstellungen über unser Cookie-Banner verwalten.",
      ],
    },
    {
      title: "7. Analyse und Tracking",
      body: [
        "Sofern wir Analyse- oder Marketingdienste einsetzen, können dabei Informationen über die Nutzung unserer Website verarbeitet werden.",
        "[Hier nur die tatsächlich eingesetzten Dienste eintragen, z. B. Google Analytics, Meta Pixel etc.]",
      ],
    },
    {
      title: "8. Social Media",
      body: [
        "Auf unserer Website können Links zu unseren Social-Media-Profilen enthalten sein.",
        "Beim Anklicken eines solchen Links verlassen Sie unsere Website. Für die Verarbeitung personenbezogener Daten auf der jeweiligen Plattform ist grundsätzlich der jeweilige Plattformbetreiber verantwortlich.",
      ],
    },
    {
      title: "9. Ihre Rechte",
      body: ["Sie haben im Rahmen der gesetzlichen Voraussetzungen insbesondere folgende Rechte:"],
      bullets: [
        "Recht auf Auskunft",
        "Recht auf Berichtigung",
        "Recht auf Löschung",
        "Recht auf Einschränkung der Verarbeitung",
        "Recht auf Datenübertragbarkeit",
        "Recht auf Widerspruch gegen bestimmte Verarbeitungen",
        "Recht auf Widerruf einer erteilten Einwilligung",
      ],
      after: [
        "Sie haben außerdem das Recht, sich bei einer Datenschutzaufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten zu beschweren.",
      ],
    },
    {
      title: "10. Speicherdauer",
      body: [
        "Wir speichern personenbezogene Daten nur so lange, wie dies für die jeweiligen Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.",
      ],
    },
    {
      title: "11. Aktualisierung",
      body: [
        "Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn sich unsere Website, eingesetzte Dienste oder gesetzliche Anforderungen ändern.",
      ],
    },
  ],
};

export const AGB = {
  slug: "agb",
  title: "Allgemeine Geschäftsbedingungen",
  subtitle: "AGB von Gold Media Studio",
  blocks: [
    {
      title: "1. Geltungsbereich",
      body: [
        "Diese Allgemeinen Geschäftsbedingungen gelten für sämtliche Leistungen von Gold Media Studio gegenüber unseren Kunden, soweit im jeweiligen Einzelvertrag nichts Abweichendes vereinbart wurde.",
        "Unsere Leistungen umfassen insbesondere Video- und Filmproduktion, Fotografie, Eventproduktion, Content-Produktion, Werbeproduktion, Social-Media-Content, Postproduktion, Webdesign und damit verbundene kreative Dienstleistungen.",
      ],
    },
    {
      title: "2. Vertragsschluss",
      body: [
        "Ein Vertrag kommt durch die Annahme unseres Angebots durch den Kunden oder durch eine anderweitige ausdrückliche Vereinbarung zwischen den Parteien zustande.",
        "Leistungsumfang, Vergütung, Termine und sonstige projektspezifische Bedingungen werden im jeweiligen Angebot bzw. Vertrag festgelegt.",
      ],
    },
    {
      title: "3. Leistungen und Änderungen",
      body: [
        "Wir erbringen die im jeweiligen Angebot vereinbarten Leistungen.",
        "Änderungen oder zusätzliche Leistungen, die nach Vertragsschluss vom Kunden gewünscht werden, können zu zusätzlichen Kosten und einer Anpassung des Zeitplans führen.",
        "Zusätzliche Leistungen werden nach vorheriger Abstimmung berechnet.",
      ],
    },
    {
      title: "4. Mitwirkungspflichten des Kunden",
      body: [
        "Der Kunde stellt uns alle für die Durchführung des Projekts erforderlichen Informationen, Materialien, Zugänge und Freigaben rechtzeitig zur Verfügung.",
        "Verzögerungen aufgrund fehlender Mitwirkung des Kunden können zu einer entsprechenden Verschiebung der vereinbarten Fertigstellung führen.",
      ],
    },
    {
      title: "5. Termine und Produktion",
      body: [
        "Bei Foto-, Video- und Eventproduktionen werden Produktionstermine individuell vereinbart.",
        "Der Kunde ist dafür verantwortlich, erforderliche Genehmigungen, Zugänge oder sonstige notwendige Voraussetzungen bereitzustellen, soweit diese nicht ausdrücklich von uns übernommen wurden.",
      ],
    },
    {
      title: "6. Vergütung und Zahlungsbedingungen",
      body: [
        "Die vereinbarte Vergütung ergibt sich aus dem jeweiligen Angebot oder Vertrag.",
        "Sofern nichts anderes vereinbart wurde, sind Rechnungen innerhalb der auf der Rechnung angegebenen Zahlungsfrist zu begleichen.",
        "Bei größeren Produktionen kann eine Anzahlung oder Teilzahlung vereinbart werden.",
      ],
    },
    {
      title: "7. Nutzungsrechte",
      body: [
        "Urheberrechte und sonstige Rechte an von uns erstellten Fotos, Videos, Designs, Konzepten und sonstigen kreativen Arbeiten verbleiben grundsätzlich bei uns, soweit nicht ausdrücklich etwas anderes vereinbart wurde.",
        "Der Kunde erhält die im jeweiligen Angebot oder Vertrag vereinbarten Nutzungsrechte.",
        "Eine weitergehende Nutzung, Bearbeitung oder Weitergabe kann von einer zusätzlichen Vergütung abhängig sein.",
      ],
    },
    {
      title: "8. Rohmaterial",
      body: [
        "Rohmaterial, Projektdateien und interne Produktionsdateien sind grundsätzlich nicht Bestandteil der vereinbarten Lieferung, sofern dies nicht ausdrücklich vereinbart wurde.",
      ],
    },
    {
      title: "9. Abnahme und Korrekturen",
      body: [
        "Sofern eine Abnahme vereinbart wurde, wird dem Kunden die fertige Leistung zur Prüfung zur Verfügung gestellt.",
        "Im vereinbarten Leistungsumfang enthaltene Korrekturschleifen werden entsprechend dem jeweiligen Angebot durchgeführt.",
        "Zusätzliche Änderungswünsche können separat berechnet werden.",
      ],
    },
    {
      title: "10. Haftung",
      body: [
        "Wir haften nach den gesetzlichen Vorschriften.",
        "Eine Haftungsbeschränkung gilt nicht für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit sowie in Fällen von Vorsatz oder grober Fahrlässigkeit.",
      ],
    },
    {
      title: "11. Höhere Gewalt",
      body: [
        "Sollten Leistungen aufgrund von Ereignissen außerhalb unseres Einflussbereichs, beispielsweise Naturkatastrophen, behördlichen Maßnahmen, technischen Großstörungen oder vergleichbaren Ereignissen, nicht oder nur verzögert erbracht werden können, werden die Parteien gemeinsam eine angemessene Lösung und gegebenenfalls einen Ersatztermin vereinbaren.",
      ],
    },
    {
      title: "12. Referenznutzung",
      body: [
        "Sofern nichts anderes schriftlich vereinbart wurde, dürfen abgeschlossene Projekte zu Referenz- und Portfoliozwecken präsentiert werden.",
        "Dies gilt nicht, soweit dadurch berechtigte Interessen des Kunden oder vereinbarte Vertraulichkeit verletzt werden.",
      ],
    },
    {
      title: "13. Vertraulichkeit",
      body: [
        "Beide Parteien verpflichten sich, vertrauliche Informationen, die ihnen im Rahmen der Zusammenarbeit bekannt werden, vertraulich zu behandeln.",
      ],
    },
    {
      title: "14. Schlussbestimmungen",
      body: [
        "Es gilt das Recht der Bundesrepublik Deutschland unter Beachtung zwingender Verbraucherschutzvorschriften.",
        "Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.",
      ],
    },
  ],
};

export const STORNO = {
  slug: "stornierung",
  title: "Stornierungs- und Erstattungsbedingungen",
  subtitle: "Bedingungen für Stornierungen und Erstattungen",
  blocks: [
    {
      title: "1. Allgemeines",
      body: [
        "Unsere Leistungen werden individuell für jeden Kunden geplant und produziert. Deshalb gelten für Stornierungen und Erstattungen grundsätzlich die im jeweiligen Angebot oder Vertrag vereinbarten Bedingungen.",
        "Gesetzliche Rechte, insbesondere gesetzliche Widerrufsrechte von Verbrauchern, bleiben unberührt.",
      ],
    },
    {
      title: "2. Stornierung durch den Kunden",
      body: [
        "Eine Stornierung muss in Textform, beispielsweise per E-Mail, erfolgen.",
        "Bei einer Stornierung können bereits erbrachte Leistungen, reservierte Produktionskapazitäten sowie nachweislich entstandene und nicht mehr stornierbare Kosten berücksichtigt werden.",
        "Die konkreten Stornierungsbedingungen können je nach Projekt, Produktionsumfang und Termin individuell im Angebot oder Vertrag vereinbart werden.",
      ],
    },
    {
      title: "3. Anzahlungen",
      body: [
        "Bereits geleistete Anzahlungen können zur Deckung bereits entstandener Aufwendungen und reservierter Produktionsleistungen verwendet werden, soweit dies vertraglich vereinbart und gesetzlich zulässig ist.",
        "Eine Erstattung erfolgt, soweit nach den gesetzlichen Vorschriften und den individuellen Vertragsbedingungen ein Erstattungsanspruch besteht.",
      ],
    },
    {
      title: "4. Verschiebung eines Produktionstermins",
      body: [
        "Bei Foto-, Video- oder Eventproduktionen kann eine Terminverschiebung nach vorheriger Abstimmung möglich sein.",
        "Ob eine Verschiebung kostenfrei möglich ist, hängt insbesondere von der Verfügbarkeit des neuen Termins sowie bereits entstandenen Kosten ab.",
      ],
    },
    {
      title: "5. Stornierung durch uns",
      body: [
        "Sollten wir eine vereinbarte Leistung aus Gründen, die wir zu vertreten haben, nicht erbringen können, werden wir uns zunächst um einen geeigneten Ersatztermin oder eine andere angemessene Lösung bemühen.",
        "Ist keine angemessene Lösung möglich, werden bereits geleistete Zahlungen für nicht erbrachte Leistungen nach den gesetzlichen und vertraglichen Bestimmungen erstattet.",
      ],
    },
    {
      title: "6. Gesetzliche Verbraucherrechte",
      body: [
        "Gesetzliche Verbraucherrechte bleiben von diesen Bedingungen unberührt.",
        "Insbesondere kann Verbrauchern bei Fernabsatzverträgen grundsätzlich ein gesetzliches Widerrufsrecht zustehen.",
        "Bei Dienstleistungen gelten hierfür besondere gesetzliche Regelungen.",
      ],
    },
    {
      title: "7. Individuelle Vereinbarungen",
      body: [
        "Bei größeren Produktionen, Hochzeiten, Veranstaltungen oder langfristigen Projekten können im jeweiligen Vertrag individuelle Stornierungs- und Zahlungsbedingungen vereinbart werden.",
        "Im Falle von Widersprüchen zwischen diesen Bedingungen und einer individuellen schriftlichen Vereinbarung geht die individuelle Vereinbarung vor, soweit gesetzlich zulässig.",
      ],
    },
  ],
};

export const LEGAL_DOCS = { impressum: IMPRESSUM, datenschutz: DATENSCHUTZ, agb: AGB, stornierung: STORNO };
